import NavLink from 'next/link';
import PropTypes from 'prop-types';
import {memo} from 'react';

import {Avatar, Text} from '../../../ui';
import css from '../../styles/UserInfo.module.css';

const UserInfo = ({avatar, name, link}) => {
  return (
    <NavLink href={link}>
      <a>
        <div className={css.user}>
          <div className={css.userImage}>
            <Avatar
              color={'white'}
              size={'extraSmall'}
              firstName={name?.split(' ')[0] || ''}
              lastName={name?.split(' ')[1] || ''}
              picture={avatar}
            />
          </div>
          <div>
            <Text
              tagComponent={Text.TAG.SPAN}
              fontSize={Text.FONT_SIZE.SIZE_14}
              fontWeight={Text.FONT_WEIGHT.BOLD}
              lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1}
              transform={Text.TRANSFORM.CAPITALIZE}
            >
              {name}
            </Text>
          </div>
        </div>
      </a>
    </NavLink>
  );
};

export default memo(UserInfo);

UserInfo.propTypes = {
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};
